import { forwardRef } from 'react';

import { IconProps } from '.';

export const FilterIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" ref={ref} {...props} {...{ className }}>
      <path
        d="M11.8001 8.60005L15.2001 5.20005C15.5001 4.90005 15.3001 4.30005 14.8001 4.30005H5.2001C4.8001 4.30005 4.5001 4.80005 4.8001 5.20005L8.2001 8.60005C8.4001 8.70005 8.5001 9.00005 8.5001 9.30005V13C8.5001 13.3 8.6001 13.5 8.8001 13.7L10.7001 15.6C11.0001 15.9 11.6001 15.7 11.6001 15.2V9.30005C11.5001 9.00005 11.6001 8.70005 11.8001 8.60005Z"
        fill="currentColor"
      />
    </svg>
  );
});

export default FilterIcon;
